export default __webpack_public_path__ + "static/game-select-6c3a621726276ba3af49a5804e4f6ab3.png";